import { useEffect } from 'react';

import { useLandingPage } from 'src/app/pages/search/shared/hooks';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';

export function usePageBody() {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	const trackOnce = useTrackOnce();

	useEffect(() => {
		// This will track the event only after the landing page disappears and the search view shows
		// Comparing against false because the value needs to be initialized first and it starts as undefined
		if (!showLandingPage) void trackOnce('search_result_view');
	}, [showLandingPage, trackOnce]);
}
